"use client"

import { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import "./ServiceDetailManager.css"

export default function AdminServiceDetail() {
    const { id } = useParams()
    const navigate = useNavigate()
    const [service, setService] = useState(null)

    useEffect(() => {
        // TODO: Fetch service data from API
        // For now using mock data
        setService({
            id: id,
            name: `Service ${id}`,
            img_title: "/placeholder.svg?height=100&width=300",
            image: "/placeholder.svg?height=200&width=200",
            category: "Architecture",
            description: "This is a detailed description of the service.",
        })
    }, [id])

    if (!service) {
        return <div>Loading...</div>
    }

    return (
        <div className="sdm-container">
            <div className="sdm-header">
                <h1 className="sdm-heading">Service Details</h1>
                <button className="sdm-back-button" onClick={() => navigate(-1)}>
                    Back to List
                </button>
            </div>
            <div className="sdm-content">
                <div className="sdm-image-section">
                    <img src={service.image} alt={service.name} className="sdm-main-image" />
                </div>
                <div className="sdm-info-section">
                    <h2>{service.name}</h2>
                    <p className="sdm-category">Category: {service.category}</p>
                    <div className="sdm-description">
                        <h3>Description</h3>
                        <p>{service.description}</p>
                    </div>
                </div>
            </div>
        </div>
    )
} 